import { useContext } from "react";
import { validationTransactionBatch } from "../../validation/validationTransactionBatch";
import { UpdateBatchQty } from "./utilites/updateBatchQty";
import { switchh } from "../../../context/switch";
import { action } from "../../../context/action";
import { CurrentTime } from "../../current";
import { createTransaction } from './utilites/createTransaction';

export default function useUpdateInventoryService () {
    const { setLoadingProcess } = useContext(switchh);
    const { setErrorMessage } = useContext(action);
    
    const AddOnBatch = async (transaction, meta, Reset) => {
        if(!transaction || !meta) {
            setErrorMessage("mission data in updateBatch");
            return
        }

        setLoadingProcess(true);
    
        const validation = validationTransactionBatch(
            transaction
        );

        
        if (!validation.success) {
            setErrorMessage(validation.message);
            setLoadingProcess(false);
            return;
        }
        
        try {
            const statusUpdateCurrentQty = await UpdateBatchQty(meta,transaction);
            
    
            if (!statusUpdateCurrentQty.status) {
                setErrorMessage(statusUpdateCurrentQty.message);
                return;
            }
    
            const current = CurrentTime(true, true);
    
            await createTransaction(
                transaction.batchId,
                current,
                statusUpdateCurrentQty.message,
                transaction
            );
            if(Reset) {
                Reset();
            }
    
        } catch (err) {
            console.log(err);
            setErrorMessage("Something went wrong");
        } finally {
            setLoadingProcess(false);
        }
    };

    return { AddOnBatch }
}